// Axios
import axiosInstance from '../axios/axiosInstance';

// Sign in a user
const cadastro = async (data) => {
  try {
    // Envia a primeira requisição POST
    const postRes = await axiosInstance.post(`produtos/`, data.formData ? data.formData : data);

    // Se o ID for retornado, faz a requisição PATCH
    if (postRes.data.id) {
      const patchRes = await axiosInstance.patch(`produtos/${postRes.data.id}/`, {
        marcaDeCompra: data.marcaDeCompra,
      });
      return patchRes.data; // Retorna a resposta da requisição PATCH
    }

    return postRes.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const cadastroCsv = async (data) => {
  try {
    // Envia a primeira requisição POST
    const postRes = await axiosInstance.post(`cadastro-csv/`, data);
    return postRes.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const updateCsv = async (data) => {
  try {
    const postRes = await axiosInstance.patch(`update-csv/`, data);
    return postRes.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const updateProduto = async (data) => {
  try {
    const postRes = await axiosInstance.patch(
      `produtos/${data.id}`,
      data.formData ? data.formData : data
    );

    if (postRes) {
      await axiosInstance.patch(`produtos/${data.id}/`, {
        marcaDeCompra: data.marcaDeCompra,
      });
    }
    return postRes.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const postCadastroMaquinario = async (data) => {
  try {
    const res = await axiosInstance.post('maquinario/', data);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getProdutoInEquipamento = async (id) => {
  try {
    const res = await axiosInstance.get(`produto/inequip/${id}`);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const postProdutoInEquipamento = async (data) => {
  try {
    const res = await axiosInstance.post('produtoInEquipamento/', data);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const produtos = async () => {
  try {
    const res = await axiosInstance.get('produto/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const postEntradaNfProduct = async (data) => {
  try {
    const res = await axiosInstance.post('nfFiscal/create/', data);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getEntradaNfProduct = async () => {
  try {
    const res = await axiosInstance.get('nfFiscal/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getCategorias = async () => {
  try {
    const res = await axiosInstance.get('categoria/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getLinhas = async () => {
  try {
    const res = await axiosInstance.get('linha/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getMarcas = async () => {
  try {
    const res = await axiosInstance.get('marca/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getEquipamentosAr = async (id) => {
  try {
    const res = await axiosInstance.get(`equipamentoAr/?q=${id}`);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getEstoqueBaixo = async () => {
  try {
    const res = await axiosInstance.get('estoque-baixo/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};
const postStatusEstoqueBaixo = async (data) => {
  try {
    const res = await axiosInstance.patch(`status-produto/${data.pk}`, {
      statusEstoque: data.status,
    });
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const CadastroProduct = {
  cadastro,
  produtos,
  postEntradaNfProduct,
  getEntradaNfProduct,
  getCategorias,
  getLinhas,
  postCadastroMaquinario,
  postProdutoInEquipamento,
  getProdutoInEquipamento,
  getMarcas,
  getEquipamentosAr,
  updateProduto,
  cadastroCsv,
  updateCsv,
  getEstoqueBaixo,
  postStatusEstoqueBaixo,
};

export default CadastroProduct;
